import { render, staticRenderFns } from "./InsuredEmployees.vue?vue&type=template&id=af2ef090&scoped=true"
import script from "./InsuredEmployees.vue?vue&type=script&lang=js"
export * from "./InsuredEmployees.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InsuredEmployees.vue?vue&type=style&index=1&id=af2ef090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2ef090",
  null
  
)

export default component.exports